import { Navigate, useLocation } from 'react-router';

import Layout from '@/app/layout';
import { ROUTE_HOME } from '@/constants/router';
import { useUserStore } from '@/store/userStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAuthenticated = useUserStore((state) => state.isAuthenticated);

  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={ROUTE_HOME} state={{ location }} />;
  }

  return <Layout>{children}</Layout>;
};
